var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"locations"},[_c('v-container',{staticClass:"my-5"},[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',[_vm._v("\n        locations\n        ")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }